import { makeAutoObservable } from 'mobx';
import { ElectionMainMenu, MenuItem } from '~/definitions/election';
import getElectionMenu from './fn/getElectionMenu';
import getRegions from './fn/getRegions';
import getElections from './fn/getElections';
import { Election, Region } from '~/definitions/region';

export default class ElectionMenuStore {
    electionMenu: ElectionMainMenu | null = null;
    isCompanyLevel: boolean = true;
    isCompanyLevelPreSelected: boolean = false;
    selectedElectionMenu: MenuItem | null = null;
    election: Election | null = null;
    regions: Region[] = [];

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.isCompanyLevel = true;
        this.election = null;
        this.regions = [];
    }

    setElectionMenu = (electionMenu: ElectionMainMenu) => {
        this.electionMenu = electionMenu;
    };

    setIsCompanyLevel = (isCompany: boolean) => {
        this.isCompanyLevel = isCompany;
    };

    setIsCompanyLevelPreSelected = (isCompany: boolean) => {
        this.isCompanyLevelPreSelected = isCompany;
    };

    setSelectedElectionMenu(item: MenuItem | null) {
        this.selectedElectionMenu = item;
    }

    getIsCompanyLevel = () => {
        // S-lag (Company) or Region
        return this.isCompanyLevel;
    };

    getIsCompanyLevelPreSelected = () => {
        return this.isCompanyLevelPreSelected;
    };

    setElection = (election: typeof this.election) => {
        this.election = election;
    };

    setRegions = (regions: typeof this.regions) => {
        this.regions = regions;
    };

    getElectionMenu = getElectionMenu;
    getElections = getElections;
    getRegions = getRegions;
}
